export const DISPUTE_GIG_TYPE = 0
export const DISPUTE_JOB_TYPE = 1
